import { Redirect, useParams } from 'react-router-dom';

import { IS_SUA } from '../../config/constants';
import RegistrationNoSuaLoader from './parts/RegistrationNoSuaLoader';
import RegistrationForm from './parts/RegistrationForm';
import IdentificationTypesLoader from '../../components/IdentificationTypesLoader';

const RegistrationNoSua = () => {
  const { studyPlanVersionOfferPeriodAdmissionId: carrerId } = useParams<{
    studyPlanVersionOfferPeriodAdmissionId: string;
  }>();

  if (IS_SUA) {
    return <Redirect to="/auth" />;
  }

  if (!carrerId) {
    return (
      <IdentificationTypesLoader>
        {({ data: identificationTypes }) => {
          return <RegistrationForm identificationTypes={identificationTypes} />;
        }}
      </IdentificationTypesLoader>
    );
  }

  return (
    <IdentificationTypesLoader>
      {({ data: identificationTypes }) => {
        return (
          <RegistrationNoSuaLoader
            studyPlanVersionOfferPeriodAdmissionId={carrerId}
          >
            {({ data }) => {
              return (
                <RegistrationForm
                  career={data}
                  identificationTypes={identificationTypes}
                />
              );
            }}
          </RegistrationNoSuaLoader>
        );
      }}
    </IdentificationTypesLoader>
  );
};

export default RegistrationNoSua;
